
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: Storytelling
* Copyright IBM Corp. 2017, 2020
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'story': 'Scénář',
	'noDashboardFound': 'Scénář se nepodařilo načíst. Buďto již neexistuje, nebo k němu nemáte dostatečná oprávnění a nemůžete jej zobrazit.',
	'noDashboardCapability': 'Nemáte možnost používat scénáře.',
	'noDashboardPermision': 'Nemáte dostatečná oprávnění pro zobrazení tohoto scénáře.',
	'defaultName': 'Nový scénář',
	'storyProperties': 'Vlastnosti scénáře',
	'createAvDataStoryLabel': 'Scénář',
	'createAvSlideShowLabel': 'Prezentace',
	'createAvPanAndZoomLabel': 'Cesta s průvodcem',
	'dashboard_save_success': 'Váš scénář byl uložen.',
	'cmEmptySelection': 'Scénář byl odstraněn. Zkuste provést uložení jako nový scénář.',
	'createStoryTitle': 'Vytvořit scénář',
	'transitionStyleTitle': 'Styl přechodů',
	'createButton': 'Vytvořit',
	'cancelButton': 'Storno',
	'dashboardResetTitle': 'Resetovat scénář',
	'dashboardResetMessage': 'Opravdu chcete zrušit všechny změny provedené pro tento scénář?',
	'dashboardResetToast': 'Váš scénář byl resetován.',
	'filter_drag_and_drop_all_tabs': 'Přetáhněte data sem, aby se filtrovaly všechny scény.',
	'filter_drag_and_drop_current_tab': 'Přetáhněte data sem, aby se filtrovala tato scéna.',
	'filterIconLabel_Global': 'Všechny scény',
	'filterIconLabel_Tab': 'Tato scéna',
	'filterIconTooltip_Global': 'Všechny scény',
	'filterIconTooltip_Tab': 'Tato scéna',
	'filterOverflowMenu_Global': 'Nabídka přetečení všech scén',
	'filterOverflowMenu_Tab': 'Nabídka přetečení této scény',
	'renameScene': 'Přejmenovat scénu',
	'duplicateScene': 'Duplikovat scénu',
	'deleteScene': 'Odstranit scénu',
	'editTimelineHighlight': 'Upravit zvýraznění',
	'deleteTimelineHighlight': 'Odstranit zvýraznění',
	'filter_includesAll': 'Zahrnuje vše',
	'timeline_highlight_moved_to': 'Zvýraznění časové osy %{id} bylo přesunuto na místo %{time}',
	'filter_tooltip': '[%{title}] - %{description}',
	'selectLabel': 'Vybrat',
	'newDefaultStoryName': 'Scénář: %{modelName}',
	'exportLabel': 'Uložit',
	'exportAsLabel': 'Uložit jako:',
	'exportDialogTitle': 'Uložit jako scénář',
	'exportDialogFooter': 'Tlačítka Uložit a Zrušit',
	'loadAfterExportLabel': 'Po uložení otevřít scénář',
	'selectTemplateLabel': 'Vybrat šablonu',
	'outOfBoundsWarningMessage': 'Některé moduly widget panelu dashboard jsou mimo mřížku a nemusí být po exportu správně zobrazeny.',
	'emptyExploreCardsWarningMessage': 'Při uložení jako scénář byly prázdné karty odstraněny.',
	'dashboard_export_success': 'Váš panel dashboard byl úspěšně uložen jako scénář.',
	'explore_export_success': 'Vaše prozkoumání bylo úspěšně uloženo jako scénář.',
	'toastUpgradeDone': 'Váš scénář byl upgradován. Kvůli optimálnímu výkonu proveďte nyní uložení.',
	'navigationMarker': 'Značka navigace',
	'navigateMarkers': 'Značky navigace',
	'navNextMarker': 'Značka Další',
	'navPrevMarker': 'Značka Předchozí',
	'navPrevMarkerAbbreviated': 'Značka Předchozí',
	'timelineSettingsButton': 'Volby přehrávání',
	'autoPlay': 'Přehrát všechny scény',
	'loop': 'Přehrávat ve smyčce',
	'refreshData': 'Aktualizovat při spuštění',
	'slideshowLabel': 'Prezentace',
	'panAndZoomLabel': 'Cesta s průvodcem',
	'slideShowLayoutLabel': 'Rozvržení s prezentací',
	'panAndZoomLayoutLabel': 'Rozvržení cesty s průvodcem',
	'panAndZoomLayoutFooter': 'Rozvržení cesty s průvodcem je kolekce scén na jednom plátně. Spustíte-li tento typ scénáře, prezentace se přesouvá po jednotlivých scénách v určeném pořadí a mění se přiblížení. Liší se od rozvržení prezentace se snímky, u které se každá scéna zobrazuje na novém plátně. Rozvržení cesty s průvodcem obsahující tři scény propojené čarami umožňuje vytvořit vodorovnou posloupnost scén. To je užitečné při zobrazování časové osy.',
	'PanAndZoomLayout1': '5 scén uspořádaných do obdélníku',
	'PanAndZoomLayout2': '4 scény uspořádané jako schodiště zleva doprava',
	'PanAndZoomLayout3': '6 scén uspořádaných do obdélníku',
	'PanAndZoomLayout4': '7 scén uspořádaných do obdélníku se 6 malými scénami nahoře a 1 velkou scénou dole',
	'PanAndZoomLayout5': '3 scény uspořádané se 2 malými scénami nahoře a 1 velkou scénou dole',
	'PanAndZoomLayout6': 'Posloupnost 4 scén uspořádaných vodorovně',
	'pageSelectWarning': 'Vyberte scénář.',
	'noSceneTransitionLabel': 'Žádný',
	'sceneTransitionPropertyLabel': 'Přechod scény',
	'animatedPathSceneTransitionLabel': 'Animovaná cesta',
	'sweepSceneTransitionLabel': 'Pohyb',
	'storyTypeLabel': 'Typ scénáře',
	'layoutLabel': 'Rozvržení',
	'tabName_animation': 'Animace',
	'propAniAnimation': 'Animace',
	'propAniTypeEntrance': 'Vstupní animace',
	'propAniDirectionIn': 'Vstupní směr',
	'propAniTypeExit': 'Výstupní animace',
	'propAniDirectionOut': 'Výstupní směr',
	'propAniDirection': 'Směr',
	'propAniEntrance': 'Vstup',
	'propAniTypeEntranceSlideIn': 'Zasunout',
	'propAniTypeEntranceFadeIn': 'Rozetmít',
	'propAniTypeEntrancePivotIn': 'Stočit',
	'propAniTypeEntranceScaleIn': 'Zvětšovat',
	'propAniTypeEntranceShrinkIn': 'Stáhnout',
	'propAniDirectionInLeft': 'Zleva',
	'propAniDirectionInRight': 'Zprava',
	'propAniDirectionInTop': 'Shora',
	'propAniDirectionInBottom': 'Zdola',
	'propAniExit': 'Ukončit',
	'propAniTypeExitSlideIn': 'Vysunout',
	'propAniTypeExitFadeIn': 'Setmít',
	'propAniTypeExitPivotOut': 'Roztočit',
	'propAniTypeExitScaleIn': 'Zmenšovat',
	'propAniTypeExitExpandOut': 'Roztáhnout',
	'propAniDirectionOutLeft': 'Doleva',
	'propAniDirectionOutRight': 'Doprava',
	'propAniDirectionOutTop': 'Na začátek',
	'propAniDirectionOutBottom': 'Na konec',
	'propAniEntranceTime': 'Začátek za (s):',
	'propAniExitTime': 'Konec za (s):',
	'animationNoEntranceText': 'Vstupní animace se neprovede, pokud se modul widget nachází na začátku scény.',
	'animationNoExitText': 'Výstupní animace se neprovede, pokud se modul widget nachází na konci scény.',
	'propAniTypeDataEntrance': 'Vstup dat',
	'propAniRevealDuration': 'Doba trvání vstupní animace',
	'timelineAnimationProperties': 'Otevřít vlastnosti animace',
	'scenesPropertiesSection': 'Scény',
	'editStoryCoachMarkTitle': 'Upravit scénář',
	'editStoryCoachMarkContents': 'Chcete-li tento scénář upravit, klepněte na ikonu tužky.',
	'addDataStoryCoachMarkContents': 'Pomocí myši přetáhněte data z panelu dat do scénáře.',
	'expandSceneCoachmarkTitle': 'Otevřít časovou osu',
	'expandSceneCoachmarkContents': 'Scénu lze animovat provedení úpravy viditelnosti objektů podle času a doby trvání.',
	'overviewCoachmarkTitle': 'Přehledové scény',
	'overviewCoachmarkContents': 'Prostřednictvím přehledových scén na začátku a konci scénáře lze zobrazit celkový kontext všech scén. Z přehledové scény lze přetažením vyměnit scénu s jinou. Přehledové scény lze zobrazit nebo skrýt v rámci vlastností scénáře.',
	'animatedPathCoachmarkTitle': 'Animovaná cesta',
	'animatedPathCoachmarkContents': 'Chcete-li animovat objekt mezi dvěma scénami, duplikujte scénu s objektem. Poté objekt v nové scéně přesuňte, otočte nebo změňte jeho velikost.',
	'propShowStoryOverviewFirstSlide': 'Zobrazit všechny scény na začátku',
	'propShowStoryOverviewLastSlide': 'Zobrazit všechny scény na konci',
	'storySceneSingleCountLabel': '1 scéna',
	'storySceneCountLabel': 'Počet scén: %{count}',
	'storySceneRangeCountLabel': 'Scéna %{index} z %{count}',
	'storySceneExpand': 'Otevřít časovou osu',
	'storySceneActionMenu': 'Nabídka voleb spuštění scény',
	'timelineRightContainerLabel': 'Skupina ovládacích prvků tlačítek časové osy',
	'timelineViewLabel': 'Časová osa',
	'timelineZoomFit': 'Změnit měřítko podle rozměrů',
	'timelineZoomIn': 'Přiblížit',
	'timelineZoomOut': 'Oddálit',
	'timelinePositionIndicator': 'indikátor pozice na časové ose na pozici %{position}',
	'timelinePositionIndicatorMoveLeftTo': 'přesunout indikátor pozice na časové ose doleva na pozici %{position}',
	'timelinePositionIndicatorMoveRightTo': 'přesunout indikátor pozice na časové ose doprava na pozici %{position}',
	'sceneStart': 'Přejít na začátek scény na pozici %{position}',
	'sceneEnd': 'Přejít na konec scény na pozici %{position}',
	'timelineHighlightTitle': 'Zvýraznit',
	'addTimelineHighlight': 'Přidat zvýraznění',
	'addSceneBtnTitle': 'Přidat novou scénu s výchozí šablonou',
	'addSceneChevronBtnTitle': 'Zvolte šablonu scény.',
	'timelinePlay': 'Přehrát',
	'timelinePause': 'Pozastavit',
	'sceneNavigation': 'Navigace ve scéně',
	'navNextScene': 'Další scéna',
	'navPrevScene': 'Předchozí scéna',
	'navPrevSceneAbbreviated': 'Předchozí scéna',
	'navExitFullScreen': 'Ukončit režim celé obrazovky',
	'navToggleOverview': 'Přepnout přehled',
	'rowNumber': 'Řádek %{number}',
	'overviewBtnLabel': 'Přehled',
	'sceneListStart': 'Začátek přehledu',
	'sceneListEnd': 'Konec přehledu',
	'timelineLeftHandle': 'levý úchyt pro položku %{name}',
	'timelineRightHandle': 'pravý úchyt pro položku %{name}',
	'timelineLeftHandleNoTitle': 'levý úchyt',
	'timelineRightHandleNoTitle': 'pravý úchyt',
	'timelineMoveLeft': 'Přesunout objekt %{object} doleva',
	'timelineMoveRight': 'Přesunout objekt %{object} doprava',
	'timelineMoveWidget': 'modul widget časové osy byl přesunut na %{newStartTime} a %{newEndTime}',
	'timelineMoveWidgetStartTime': 'čas zahájení u modulu časové osy byl změněn na %{newStartTime}',
	'timelineMoveWidgetEndTime': 'čas ukončení u modulu časové osy byl změněn na %{newEndTime}',
	'timelineMoveWidgetDown': 'modul widget časové osy byl přesunut dolů',
	'timelineMoveWidgetUp': 'modul widget časové osy byl přesunut nahoru',
	'addSceneTitle': 'Přidat scénu',
	'blankSceneLayout': 'Prázdný objekt',
	'titleSceneLayout': 'Nadpis s podnadpisem',
	'sceneLayout1': 'Nadpis s textem vedle jedné vizualizace',
	'sceneLayout2': 'Nadpis s jednou vizualizací',
	'sceneLayout3': 'Nadpis se dvěma vizualizacemi',
	'sceneLayout4': 'Víceúčelové',
	'sceneLayout5': 'Bez nadpisu s textem vedle jedné vizualizace',
	'sceneLayout6': 'Víceúčelové, 2 x 2',
	'sceneLayout7': 'Víceúčelové, 2 vedle 1',
	'sceneLayout8': 'Víceúčelové, 1 vedle 2',
	'sceneLayout9': 'Víceúčelové, 1 přes 2',
	'sceneLayout10': 'Víceúčelové, 2 přes 1',
	'sceneLayout11': 'Víceúčelové, 4 přes 1',
	'sceneLayout12': 'Víceúčelové, 1 přes 1 vedle 2 x 2 přes 1',
	'titleWidgetPlaceholderText': 'Sem zadejte nadpis.',
	'subtitleWidgetPlaceholderText': 'Sem zadejte podnadpis.',
	'createStoryViewTitle': 'Vytvořit scénář',
	'defaultStoryName': 'Nový scénář',
	'screenshot_label': 'Scénář %{title}',
	'screenshot_label_scene': 'Scéna %{sceneTitle} scénáře %{title}',
	'filmstripHandleOpenLabel': 'Otevřít selektor scény',
	'filmstripHandleCloseLabel': 'Zavřít selektor scény'
});
